document.addEventListener("DOMContentLoaded", function() {
  var tabButtons = document.querySelectorAll(".tab-button");
  var tabContents = document.querySelectorAll(".tab-content");
  tabButtons.forEach(function(btn) {
    btn.addEventListener("click", function() {
      tabButtons.forEach(function(b) { b.classList.remove("active"); });
      tabContents.forEach(function(content) { content.classList.remove("active"); });
      btn.classList.add("active");
      var tabId = btn.getAttribute("data-tab");
      document.getElementById(tabId).classList.add("active");
    });
  });

  function calculateBeads(length, width) {
    return length / width;
  }
  function updateProjectBeads() {
    var length = parseFloat(document.getElementById("l1").value || 0) * 25.4;
    var width = parseFloat(document.getElementById("w1").value || 0);
    var resultField = document.getElementById("n1");
    if(!length || !width || width <= 0) {
      resultField.placeholder = "Results will be displayed here";
      resultField.value = "";
      return;
    }
    var beads = calculateBeads(length, width);
    resultField.value = "= approx. " + beads.toFixed(3) + " beads";
  }
  function updateCustomBeads() {
    var lengthInput = parseFloat(document.getElementById("l2").value || 0);
    var unit = document.getElementById("u").value;
    var width = parseFloat(document.getElementById("w2").value || 0);
    var resultField = document.getElementById("n2");
    if(!lengthInput || isNaN(width) || width <= 0 || !unit) {
      resultField.placeholder = "Results will be displayed here";
      resultField.value = "";
      return;
    }
    var lengthInMM = lengthInput;
    if(unit === "in") lengthInMM *= 25.4;
    else if(unit === "cm") lengthInMM *= 10;
    var beads = calculateBeads(lengthInMM, width);
    resultField.value = "= approx. " + beads.toFixed(3) + " beads";
  }
  document.getElementById("l1").addEventListener("change", updateProjectBeads);
  document.getElementById("w1").addEventListener("change", updateProjectBeads);
  document.getElementById("l2").addEventListener("input", updateCustomBeads);
  document.getElementById("u").addEventListener("change", updateCustomBeads);
  document.getElementById("w2").addEventListener("input", updateCustomBeads);

  var converters = {
    length: document.getElementById("lengthConverter"),
    weight: document.getElementById("weightConverter"),
    area: document.getElementById("areaConverter"),
    temperature: document.getElementById("temperatureConverter"),
    time: document.getElementById("timeConverter")
  };
  var categorySelect = document.getElementById("conversionCategory");
  categorySelect.addEventListener("change", function(e) {
    Object.values(converters).forEach(function(converter) {
      converter.classList.add("hidden");
    });
    var selectedCategory = e.target.value;
    if(selectedCategory && converters[selectedCategory]) {
      converters[selectedCategory].classList.remove("hidden");
    }
  });
  var factors = {
    length: { meter: 1, kilometer: 0.001, centimeter: 100, millimeter: 1000, mile: 0.000621371, yard: 1.09361, foot: 3.28084, inch: 39.3701 },
    weight: { kilogram: 1, gram: 1000, milligram: 1000000, pound: 2.20462, ounce: 35.274, ton: 0.001 },
    area: { squareMeter: 1, squareKilometer: 0.000001, squareCentimeter: 10000, squareMillimeter: 1000000, hectare: 0.0001, acre: 0.000247105 },
    time: { seconds: 1, minutes: 0.0166667, hours: 0.000277778, days: 0.0000115741, weeks: 0.0000016534, years: 0.0000000317098 }
  };
  function calculateResult(input, fromFactor, toFactor) {
    return (input * toFactor) / fromFactor;
  }
  function convertLength() {
    var input = parseFloat(document.getElementById("lengthInput").value);
    var from = document.getElementById("fromLengthUnit").value;
    var to = document.getElementById("toLengthUnit").value;
    if(!isNaN(input) && from && to) {
      var result = calculateResult(input, factors.length[from], factors.length[to]);
      document.getElementById("lengthResult").textContent = "Result: " + result.toFixed(3) + " " + to;
    } else {
      document.getElementById("lengthResult").textContent = "Please enter valid inputs.";
    }
  }
  function convertWeight() {
    var input = parseFloat(document.getElementById("weightInput").value);
    var from = document.getElementById("fromWeightUnit").value;
    var to = document.getElementById("toWeightUnit").value;
    if(!isNaN(input) && from && to) {
      var result = calculateResult(input, factors.weight[from], factors.weight[to]);
      document.getElementById("weightResult").textContent = "Result: " + result.toFixed(3) + " " + to;
    } else {
      document.getElementById("weightResult").textContent = "Please enter valid inputs.";
    }
  }
  function convertArea() {
    var input = parseFloat(document.getElementById("areaInput").value);
    var from = document.getElementById("fromAreaUnit").value;
    var to = document.getElementById("toAreaUnit").value;
    if(!isNaN(input) && from && to) {
      var result = calculateResult(input, factors.area[from], factors.area[to]);
      document.getElementById("areaResult").textContent = "Result: " + result.toFixed(3) + " " + to;
    } else {
      document.getElementById("areaResult").textContent = "Please enter valid inputs.";
    }
  }
  function convertTemperature() {
    var input = parseFloat(document.getElementById("temperatureInput").value);
    var from = document.getElementById("fromTemperatureUnit").value;
    var to = document.getElementById("toTemperatureUnit").value;
    if(isNaN(input) || !from || !to) {
      document.getElementById("temperatureResult").textContent = "Please enter valid inputs.";
      return;
    }
    var result;
    if(from === "celsius") {
      result = to === "fahrenheit" ? input * 1.8 + 32 : input + 273.15;
    } else if(from === "fahrenheit") {
      result = to === "celsius" ? (input - 32) / 1.8 : (input - 32) / 1.8 + 273.15;
    } else if(from === "kelvin") {
      result = to === "celsius" ? input - 273.15 : (input - 273.15) * 1.8 + 32;
    }
    document.getElementById("temperatureResult").textContent = "Result: " + result.toFixed(3) + " " + to;
  }
  function convertTime() {
    var input = parseFloat(document.getElementById("timeInput").value);
    var from = document.getElementById("fromTimeUnit").value;
    var to = document.getElementById("toTimeUnit").value;
    if(!isNaN(input) && from && to) {
      var result = calculateResult(input, factors.time[from], factors.time[to]);
      document.getElementById("timeResult").textContent = "Result: " + result.toFixed(3) + " " + to;
    } else {
      document.getElementById("timeResult").textContent = "Please enter valid inputs.";
    }
  }
  ["lengthInput","fromLengthUnit","toLengthUnit"].forEach(function(id){
    document.getElementById(id).addEventListener("input", convertLength);
    document.getElementById(id).addEventListener("change", convertLength);
  });
  ["weightInput","fromWeightUnit","toWeightUnit"].forEach(function(id){
    document.getElementById(id).addEventListener("input", convertWeight);
    document.getElementById(id).addEventListener("change", convertWeight);
  });
  ["areaInput","fromAreaUnit","toAreaUnit"].forEach(function(id){
    document.getElementById(id).addEventListener("input", convertArea);
    document.getElementById(id).addEventListener("change", convertArea);
  });
  ["temperatureInput","fromTemperatureUnit","toTemperatureUnit"].forEach(function(id){
    document.getElementById(id).addEventListener("input", convertTemperature);
    document.getElementById(id).addEventListener("change", convertTemperature);
  });
  ["timeInput","fromTimeUnit","toTimeUnit"].forEach(function(id){
    document.getElementById(id).addEventListener("input", convertTime);
    document.getElementById(id).addEventListener("change", convertTime);
  });

  function resetAll() {
    document.getElementById("l1").value = "";
    document.getElementById("w1").value = "";
    document.getElementById("n1").value = "";
    document.getElementById("n1").placeholder = "Results will be displayed here";
    document.getElementById("l2").value = "";
    document.getElementById("u").value = "";
    document.getElementById("w2").value = "";
    document.getElementById("n2").value = "";
    document.getElementById("n2").placeholder = "Results will be displayed here";
    document.getElementById("conversionCategory").value = "";
    Object.values(converters).forEach(function(converter) {
      converter.classList.add("hidden");
    });
    document.getElementById("lengthInput").value = "";
    document.getElementById("fromLengthUnit").value = "";
    document.getElementById("toLengthUnit").value = "";
    document.getElementById("lengthResult").textContent = "Result: ";
    document.getElementById("weightInput").value = "";
    document.getElementById("fromWeightUnit").value = "";
    document.getElementById("toWeightUnit").value = "";
    document.getElementById("weightResult").textContent = "Result: ";
    document.getElementById("areaInput").value = "";
    document.getElementById("fromAreaUnit").value = "";
    document.getElementById("toAreaUnit").value = "";
    document.getElementById("areaResult").textContent = "Result: ";
    document.getElementById("temperatureInput").value = "";
    document.getElementById("fromTemperatureUnit").value = "";
    document.getElementById("toTemperatureUnit").value = "";
    document.getElementById("temperatureResult").textContent = "Result: ";
    document.getElementById("timeInput").value = "";
    document.getElementById("fromTimeUnit").value = "";
    document.getElementById("toTimeUnit").value = "";
    document.getElementById("timeResult").textContent = "Result: ";
  }

  var resetBtn = document.getElementById("resetAllButton");
  resetBtn.addEventListener("click", function(e) {
    e.preventDefault();
    resetAll();
  });

});
